import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { LoadingScreen } from "../components/common/LoadingScreen";
import { UserRole } from "../models/user.model";
import { useAuth } from "./AuthProvider";

interface OperationsRouteProps {
  children: ReactNode;
  redirectPath?: string;
}

export const OperationsRoute: React.FC<OperationsRouteProps> = ({
  children,
  redirectPath = "/cvs",
}) => {
  const { isAuthenticated, userRole, inProgress, isInitialized } = useAuth();

  // If authentication is in progress, show loading state
  if (!isInitialized || inProgress !== "none") {
    return <LoadingScreen />;
  }

  // If not authenticated, redirect to home
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Role not resolved yet — wait rather than redirecting
  if (userRole === null) {
    return <LoadingScreen />;
  }

  // Allow access if user has ANY operational role (Admin or Manager)
  const hasOperationalAccess = [UserRole.Admin, UserRole.Manager].includes(userRole);

  if (!hasOperationalAccess) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};
